import Title from "@/components/common/Typography/Title"
import { useAppSelector } from "@/lib/redux/hooks"
import { Button, Col, Divider, Row } from "antd"
import type { FC } from "react"
import { useContext, useMemo } from "react"
import { SelectPlacementContext } from "."
import { useAirports } from "@/hooks/flight/useAirports"
import { TypeAirport } from "@/lib/redux/features/flight/type"
import { useTranslation } from "react-i18next"
import { useTETranslation } from "@/hooks/app/useTETranslation"

type InternationalAirportsProps = {
  /** Trong tab Quốc tế, bỏ Divider phía trên (không còn khối Domestic phía trước) */
  hideLeadingDivider?: boolean
  hideSectionTitle?: boolean
}

const InternationalAirports: FC<InternationalAirportsProps> = ({
  hideLeadingDivider = false,
  hideSectionTitle = false,
}) => {
  const { t } = useTranslation()
  const { getAirportCityName } = useTETranslation()
  const airports = useAirports()
  const internationalAirportIds = useAppSelector(state => state.flight.internationalAirports)
  const searchPopular = useAppSelector(state => state.flight.searchPopular)
  const { onChange, searching } = useContext(SelectPlacementContext)

  const internationalAirports = useMemo(
    () => Object.values(internationalAirportIds
      .reduce((obj: { [countryCode: string]: TypeAirport }, code) => {
        const airport = airports[code]
        if (!airport?.countryCode) return obj
        if (!obj[airport.countryCode]) {
          obj[airport.countryCode] = airport
        }
        return obj
      }, {})),
    [airports, internationalAirportIds]
  )

  if (searching && !searchPopular) {
    return <></>
  }

  return (
    <>
      {!hideLeadingDivider && <Divider style={{ marginBlock: '1.2rem' }} />}
      {!hideSectionTitle && (
        <Row style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
          <Title level={5} style={{ margin: 0 }}>
            {t("common.international")}
          </Title>
        </Row>
      )}
      <Row style={hideSectionTitle ? { paddingTop: '0.4rem' } : undefined}>
        {internationalAirports.map((airport) => {
            if (!airport?.code) return null
            return (
              <Col key={airport.code} style={{ paddingRight: 5, paddingBottom: 5 }} span={8}>
                <Button className="select-placement__airport-btn" onClick={() => onChange && onChange(airport)} type='text' block style={{ justifyContent: 'start' }}>
                  {getAirportCityName(airport)}
                </Button>
              </Col>
            )
          })}
      </Row>
    </>
  )
}

export default InternationalAirports